'use client';
const LOCALE_CONFIG = {
    'da-dk': {
        name: 'Danish (Denmark)'
    },
    'de-at': {
        name: 'German (Austria)',
        derivedFrom: 'de-de'
    },
    'de-ch': {
        name: 'German (Switzerland)',
        derivedFrom: 'de-de'
    },
    'de-de': {
        name: 'German (Germany)'
    },
    'en-au': {
        name: 'English (Australia)',
        derivedFrom: 'en-gb'
    },
    'en-ca': {
        name: 'English (Canada)',
        derivedFrom: 'en-us'
    },
    'en-gb': {
        name: 'English (UK)'
    },
    'en-ie': {
        name: 'English (Ireland)',
        derivedFrom: 'en-gb'
    },
    'en-in': {
        name: 'English (India)',
        derivedFrom: 'en-us'
    },
    'en-nz': {
        name: 'English (New Zealand)',
        derivedFrom: 'en-au'
    },
    'en-sg': {
        name: 'English (Singapore)',
        derivedFrom: 'en-au'
    },
    'en-us': {
        name: 'English (US)'
    },
    'es-es': {
        name: 'Spanish (Spain)'
    },
    'es-us': {
        name: 'Spanish (US)'
    },
    'fi-fi': {
        name: 'Finnish (Finland)'
    },
    'fr-be': {
        name: 'French (Belgium)',
        derivedFrom: 'fr-fr'
    },
    'fr-ca': {
        name: 'French (Canada)'
    },
    'fr-ch': {
        name: 'French (Switzerland)',
        derivedFrom: 'fr-fr'
    },
    'fr-fr': {
        name: 'French (France)'
    },
    'it-ch': {
        name: 'Italian (Switzerland)',
        derivedFrom: 'it-it'
    },
    'it-it': {
        name: 'Italian (Italy)'
    },
    'nb-no': {
        name: 'Norwegian (Bokmål)'
    },
    'nl-be': {
        name: 'Dutch (Belgium)',
        derivedFrom: 'nl-nl'
    },
    'nl-nl': {
        name: 'Dutch (Netherlands)'
    },
    'pt-pt': {
        name: 'Portuguese (Portugal)'
    },
    'sv-se': {
        name: 'Swedish (Sweden)'
    }
};
const transformToLowercaseLocale = (e)=>e.toLowerCase();
const ALL_SUPPORTED_LOCALES = Object.keys(LOCALE_CONFIG);
ALL_SUPPORTED_LOCALES.reduce((e, n)=>{
    let a = LOCALE_CONFIG[n];
    return 'derivedFrom' in a && void 0 !== a.derivedFrom && (e[n] = a.derivedFrom), e;
}, {});

export { ALL_SUPPORTED_LOCALES, LOCALE_CONFIG, transformToLowercaseLocale };
